var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cs-segment',{staticClass:"cs-page-default"},[_c('cs-container',[_c('cs-sections',{attrs:{"data":_vm.$store.state.page.content.sections,"imgRadius":"8px"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }